import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FILTER_MORE } from '../../../constants'
import CustomScrollBar from '../../../../shared/CustomScrollBar'
import PriceRange from './PriceRange/PriceRange'
import Amenities from './Amenities'
import HotelType from './HotelType'
import * as c from './constants'
import IconField from './Amenities/IconField'

class More extends PureComponent {
  onPriceChange = (field, value) => {
    const { priceChangeAction, filterApplyAction } = this.props
    priceChangeAction(field, value)
    filterApplyAction(FILTER_MORE, false)
  }

  onAmenityChange = (...args) => {
    const { amenityChangeAction, filterApplyAction } = this.props
    amenityChangeAction(args[3], args[1])
    filterApplyAction(FILTER_MORE, false)
  }

  onHotelTypeChange = (...args) => {
    const { hotelTypeChangeAction, filterApplyAction } = this.props
    hotelTypeChangeAction(args[1])
    filterApplyAction(FILTER_MORE, false)
  }

  render() {
    const {
      titles: {
        priceRange: priceRangeTitles,
        priceRange: {
          title: priceRangeTitle,
        },
        amenities: {
          title: amenitiesTitle,
          plus,
          equipment,
          showMore,
          showLess,
          icons: iconsTitles,
        },
        hotelType: hotelTypeTitles,
        eventTracking: {
          hotelType: eventTrackingDataHotelType,
          amenity: eventTrackingDataAmenity,
          extra_touches: eventTrackingDataExtraTouches,
        },
      },
      more: { priceRange, amenities, hotelType },
    } = this.props
    const amenitiesPlus = [
      c.ICON_DISABLED_PEOPLE,
      c.ICON_PETS_ALLOWED,
    ]
    const amenitiesEquipment = [
      c.ICON_PARKING,
      c.ICON_AIR_CONDITIONER,
      c.ICON_POOL,
      c.ICON_SPORTS_HALL,
      c.ICON_MEETING_ROOM,
    ]
    return (
      <div className="filter-more">
        <CustomScrollBar>
          <div className="filter-more__sub-title">
            {priceRangeTitle}
          </div>
          <PriceRange
            titles={priceRangeTitles}
            prices={priceRange}
            onPriceChange={this.onPriceChange}
          />
          <div className="filter-more__sub-title">
            {amenitiesTitle}
          </div>
          <Amenities
            blockName={plus}
            more={showMore}
            less={showLess}
            iconTitles={iconsTitles}
            icons={amenitiesPlus}
            amenities={amenities}
            onAmenityChange={this.onAmenityChange}
            eventTrackingData={eventTrackingDataExtraTouches}
          />
          <Amenities
            blockName={equipment}
            more={showMore}
            less={showLess}
            iconTitles={iconsTitles}
            icons={amenitiesEquipment}
            amenities={amenities}
            onAmenityChange={this.onAmenityChange}
            eventTrackingData={eventTrackingDataAmenity}
          />
          <HotelType
            titles={hotelTypeTitles}
            hotelType={hotelType}
            onTypeChange={this.onHotelTypeChange}
            eventTrackingData={eventTrackingDataHotelType}
          />
        </CustomScrollBar>
      </div>
    )
  }
}

More.propTypes = {
  titles: PropTypes.shape({
    label: PropTypes.string,
    title: PropTypes.string,
    clear: PropTypes.string,
    priceRange: PriceRange.propTypes.titles,
    amenities: PropTypes.shape({
      title: PropTypes.string.isRequired,
      plus: PropTypes.string.isRequired,
      equipment: PropTypes.string.isRequired,
      showMore: PropTypes.string.isRequired,
      showLess: PropTypes.string.isRequired,
      icons: IconField.propTypes.titles,
    }),
    hotelType: HotelType.propTypes.titles,
    apply: PropTypes.string,
    eventTracking: PropTypes.objectOf(String),
  }),
  more: PropTypes.objectOf(PropTypes.object),
  priceChangeAction: PropTypes.func.isRequired,
  amenityChangeAction: PropTypes.func.isRequired,
  hotelTypeChangeAction: PropTypes.func.isRequired,
  filterApplyAction: PropTypes.func.isRequired,
}

More.defaultProps = {
  titles: [],
  more: [],
}

export default More
